var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fontFamily)?_c('div',{staticClass:"pa-0",style:('--fontFamily: ' + _vm.fontFamily.value),attrs:{"id":"app"}},[_c('alert-message',{attrs:{"dialog":_vm.dialog}}),(_vm.layout == _vm.guestLayout)?[_c('guest-layout')]:_vm._e()],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }